import { createSlice } from '@reduxjs/toolkit';
import { setToStore } from '../pages/Utils/fn';
import constants from '../pages/Utils/constants.json';

export const recentlySearchedSlice = createSlice({
	name: 'recentlySearched',
	initialState: {
		data: null,
	},
	reducers: {
		setRecentlySearched: function (state, action) {
			state.data = action.payload;
		},

		addRecentlySearched: function (state, action) {
			if (!state.data || state.data.length === 0) {
				state.data = [action.payload];
			} else {
				state.data.forEach((item, index) => {
					if (item.item_code === action.payload.item_code) {
						state.data.splice(index, 1);
					}
				});
				if (state.data.length >= 20) state.data.pop();
				state.data.unshift(action.payload);
			}
			setToStore(constants.RECENTLY_SEARCHED, state.data);
		},
	},
});

export const { setRecentlySearched, addRecentlySearched } = recentlySearchedSlice.actions;
export default recentlySearchedSlice.reducer;
